/* eslint-disable import/no-cycle */
import Button from './Button';

const keyMode = {
  keyEn: [
    '`',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '0',
    '-',
    '=',
    'Backspace',
    'Tab',
    'q',
    'w',
    'e',
    'r',
    't',
    'y',
    'u',
    'i',
    'o',
    'p',
    '[',
    ']',
    '\\',
    'Del',
    'CapsLock',
    'a',
    's',
    'd',
    'f',
    'g',
    'h',
    'j',
    'k',
    'l',
    ';',
    "'",
    'Enter',
    'Shift',
    'z',
    'x',
    'c',
    'v',
    'b',
    'n',
    'm',
    ',',
    '.',
    '/',
    '↑',
    'Shift',
    'Ctrl',
    'Win',
    'Alt',
    ' ',
    'Alt',
    'Ctrl',
    '←',
    '↓',
    '→',
    'En',
  ],
  keyEnShift: [
    '~',
    '!',
    '@',
    '#',
    '$',
    '%',
    '^',
    '&',
    '*',
    '(',
    ')',
    '_',
    '+',
    'Backspace',
    'Tab',
    'Q',
    'W',
    'E',
    'R',
    'T',
    'Y',
    'U',
    'I',
    'O',
    'P',
    '{',
    '}',
    '|',
    'Del',
    'CapsLock',
    'A',
    'S',
    'D',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
    ':',
    '"',
    'Enter',
    'Shift',
    'Z',
    'X',
    'C',
    'V',
    'B',
    'N',
    'M',
    '<',
    '>',
    '?',
    '↑',
    'Shift',
    'Ctrl',
    'Win',
    'Alt',
    ' ',
    'Alt',
    'Ctrl',
    '←',
    '↓',
    '→',
    'EN',
  ],
  keyRu: [
    'ё',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '0',
    '-',
    '=',
    'Backspace',
    'Tab',
    'й',
    'ц',
    'у',
    'к',
    'е',
    'н',
    'г',
    'ш',
    'щ',
    'з',
    'х',
    'ъ',
    '\\',
    'Del',
    'CapsLock',
    'ф',
    'ы',
    'в',
    'а',
    'п',
    'р',
    'о',
    'л',
    'д',
    'ж',
    'э',
    'Enter',
    'Shift',
    'я',
    'ч',
    'с',
    'м',
    'и',
    'т',
    'ь',
    'б',
    'ю',
    '.',
    '↑',
    'Shift',
    'Ctrl',
    'Win',
    'Alt',
    ' ',
    'Alt',
    'Ctrl',
    '←',
    '↓',
    '→',
    'Ру',
  ],
  keyRuShift: [
    'Ё',
    '!',
    '"',
    '№',
    ';',
    '%',
    ':',
    '?',
    '*',
    '(',
    ')',
    '_',
    '+',
    'Backspace',
    'Tab',
    'Й',
    'Ц',
    'У',
    'К',
    'Е',
    'Н',
    'Г',
    'Ш',
    'Щ',
    'З',
    'Х',
    'Ъ',
    '/',
    'Del',
    'CapsLock',
    'Ф',
    'Ы',
    'В',
    'А',
    'П',
    'Р',
    'О',
    'Л',
    'Д',
    'Ж',
    'Э',
    'Enter',
    'Shift',
    'Я',
    'Ч',
    'С',
    'М',
    'И',
    'Т',
    'Ь',
    'Б',
    'Ю',
    ',',
    '↑',
    'Shift',
    'Ctrl',
    'Win',
    'Alt',
    ' ',
    'Alt',
    'Ctrl',
    '←',
    '↓',
    '→',
    'РУ',
  ],
};

const activeKey = (keyboardKey, el) => {
  keyboardKey.forEach((vir) => {
    if (el.altKey && vir.innerText === 'Alt') {
      vir.classList.add('keyboard-key__active');
    } else if (el.ctrlKey && vir.innerText === 'Ctrl') {
      vir.classList.add('keyboard-key__active');
    } else if (el.shiftKey && vir.innerText === 'Shift') {
      vir.classList.add('keyboard-key__active');
    } else if (el.metaKey && vir.innerText === 'Win') {
      vir.classList.add('keyboard-key__active');
    } else if (el.key === 'Delete' && vir.innerText === 'Del') {
      vir.classList.add('keyboard-key__active');
    } else if (el.key === 'ArrowUp' && vir.innerText === '↑') {
      vir.classList.add('keyboard-key__active');
    } else if (el.key === 'ArrowDown' && vir.innerText === '↓') {
      vir.classList.add('keyboard-key__active');
    } else if (el.key === 'ArrowLeft' && vir.innerText === '←') {
      vir.classList.add('keyboard-key__active');
    } else if (el.key === 'ArrowRight' && vir.innerText === '→') {
      vir.classList.add('keyboard-key__active');
    } else if (el.key === ' ' && vir.innerText === '') {
      vir.classList.add('keyboard-key__active');
    } else if (el.key === vir.innerText) {
      vir.classList.add('keyboard-key__active');
    }
  });
};

const changeLang = (keyLang, func) => {
  const button = new Button(func);
  switch (keyLang.innerText) {
    case 'En':
      button.createButtons(keyMode.keyRu);
      break;
    case 'EN':
      button.createButtons(keyMode.keyRuShift);
      break;
    case 'Ру':
      button.createButtons(keyMode.keyEn);
      break;
    case 'РУ':
      button.createButtons(keyMode.keyEnShift);
      break;
    default:
      break;
  }
};

const pressShift = (target, func) => {
  const langKeyboard = document.querySelectorAll('.keyboard-key')[64].innerText;
  const but = new Button(func);

  switch (langKeyboard) {
    case 'En':
      document.querySelector('.keyboard').innerHTML = ' ';
      but.createButtons(keyMode.keyEnShift, target);
      break;
    case 'EN':
      document.querySelector('.keyboard').innerHTML = ' ';
      but.createButtons(keyMode.keyEn, target);
      break;
    case 'Ру':
      document.querySelector('.keyboard').innerHTML = ' ';
      but.createButtons(keyMode.keyRuShift, target);
      break;
    case 'РУ':
      document.querySelector('.keyboard').innerHTML = ' ';
      but.createButtons(keyMode.keyRu, target);
      break;
    default:
      break;
  }
};

export { activeKey, keyMode, changeLang, pressShift };
